<template>
    <div :class="getStatusHeader.header.minimaze ? 'card-with-chart-op' : 'card-with-chart-op-minimaze'">
            <div class="card-with-chart__title" v-show="getStatusHeader.header.minimaze">
                <div class="card-with-chart__title_text">
                    Прогнозируемый доход
                </div>
                <des icon-class="icon icon--inline x15" icon-size="-5 0 30 30" :text="textDes"></des>
            </div>
            <div class="cardPrognosis-data">
                <div class="cardPrognosis-data-item">
                    <div class="cardPrognosis-period">за неделю</div>
                    <div :class="getStatusHeader.header.minimaze ? 'card-with-chart__data-balance' : 'card-with-chart__data-balance-minimaze'">
                            $ {{$moneyf(prognosis.week, 0)}} +{{prognosisPercent.week}}%
                    </div>
                    <transition enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut" mode="out-in">
                        <div v-show="getStatusHeader.header.minimaze" class="card-with-chart__data-maxdd color-green">
                            Вероятность 98%
                        </div>
                    </transition>
                </div>
                <div class="cardPrognosis-data-item">
                    <div class="cardPrognosis-period">за месяц</div>
                    <div :class="getStatusHeader.header.minimaze ? 'card-with-chart__data-balance' : 'card-with-chart__data-balance-minimaze'">
                            $ {{$moneyf(prognosis.moth,0)}} +{{prognosisPercent.month}}%
                    </div>
                    <transition enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut" mode="out-in">
                        <div v-show="getStatusHeader.header.minimaze" class="card-with-chart__data-maxdd color-green">
                            Вероятность 96%
                        </div>
                    </transition>
                </div>
            </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Description from '../ui-components/description'
export default {
    components: {
        'des':Description
    },
    props: {
        nameCurrency: { default: "" },
        name: { default: "" },
        widthWidget: { default: "156px" }
    },
  data() {
    return {
        statistic: {},
        textDes: 'Предполагаемая прибыль за определенный временной период',
        prognosis:{
            week:null,
            moth :null,
        },
        prognosisPercent: {
            week:null,
            month:null
        }
    };
  },
  computed: {
    ...mapGetters({
        getStatistics: "accountstat/getStatistics",
        getStatusHeader:'usersets/getSettings'
    }),
  },
  methods: {
    updateStatistics(symbol) {
        if (!symbol) symbol = this.symbol;
        let stat = this.getStatistics(symbol);
        if (!stat) {
            return;
        }
        this.statistic = stat;
        let equityAfterWeek = this.statistic.Summary.Equity + (this.statistic.Summary.Equity- 100000)*7/this.statistic.DailyRecords.length;
        let equityAfterMonth = this.statistic.Summary.Equity + (this.statistic.Summary.Equity- 100000)*30/this.statistic.DailyRecords.length;
        this.prognosis.week = equityAfterWeek - this.statistic.Summary.Equity;
        this.prognosis.moth = equityAfterMonth - this.statistic.Summary.Equity;
        this.prognosisPercent = {
            week: ((equityAfterWeek - this.statistic.Summary.Equity) / (this.statistic.Summary.Equity/100)).toFixed(2),
            month: ((equityAfterMonth - this.statistic.Summary.Equity) / (this.statistic.Summary.Equity/100)).toFixed(2)
        }
    }
  },
  created() {
    subscribeOnUpdate(this.$store, "", isFirstObtained => {
      if (!this.symbol || !this.symbol.length) {
        this.updateStatistics();
        //console.log("Prim stat widget is updated");
      }
      this.updateStatistics();
    });
  }
};

function subscribeOnUpdate(store, symbol, handler) {
  store.dispatch("accountstat/subscribeOnUpdate", {
    symbol: "",
    callback: {
      id: "header-widget-prognosis",
      handler: handler
    }
  });
}
</script>
<style lang="less" scoped>
.card-with-chart-op {
    display: flex;
    flex-direction: column;
    background: #3d536b;
    margin-right: 1px;
    padding: 8px 10px 10px 10px;
    flex-grow: 1;
    height: 88px;
    &-minimaze {
        display: flex;
        flex-direction: column;
        background: #3d536b;
        margin-right: 1px;
        padding: 4px 10px 10px 10px;
        flex-grow: 1;
        height: 88px;
    }
}
.card-with-chart__title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
	max-height: 20px;
}

.cardPrognosis-data {
    display: flex;
    &-item {
        display: block;
        align-self: flex-end;
        min-width: 135px;
        &:first-child {
            margin-right: 12px;
        }
    }
}

.cardPrognosis-period {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #aabed2;
}

.card-with-chart__data {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    min-height: fit-content;
}

.card-with-chart__title_text {
    font-family: Arimo;
    font-size: 10px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: 0.4px;
    color: #ffffff;
    max-height: 16px;
    text-transform: uppercase;
}

.card-with-chart__title_text span {
    color: #aabed2;
}

.card-with-chart__title_text-percent {
    font-family: Arimo;
    font-size: 13px;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.23;
    letter-spacing: 0.4px;
    color: @colors[green];
}

.card-with-chart__data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.card-with-chart__data-balance {
    font-family: Arimo;
    font-size: 15px;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: @colors[green];
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    &-minimaze {
        font-family: Arimo;
        font-size: 15px;
        //font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: @colors[green];
        margin-bottom: 0px;
        display: flex;
        align-items: center;
    }
}

.card-with-chart__data-percent {
    font-family: Arimo;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color: #0fd7b7;
}

.card-with-chart__data-maxdd {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: 0.4px;
    color: @colors[red];
    margin-top: 4px;
    text-transform: uppercase;
}
</style>
